"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getReducedArray = void 0;
const getReducedArray = (array, indexesAmount) => {
  // copies x amount of indexes from array (in order) to a new array

  if (array.length <= indexesAmount) return array;
  const newArr = [];
  for (let i = 0; i < indexesAmount; i++) {
    newArr.push(array[i]);
  }
  return newArr;
};
exports.getReducedArray = getReducedArray;